import React, { useState } from 'react';
import { Bug } from 'lucide-react';
import BugReportDialog from './BugReportDialog';
import { IconButton } from '../design-system';

const BugReportButton: React.FC = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <IconButton
        onClick={() => setIsDialogOpen(true)}
        aria-label="Report a bug"
        title="Report a bug"
        data-tour="bug-report-button"
        data-bug-report-trigger="true"
        icon={<Bug size={16} />}
      />

      <BugReportDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
};

export default BugReportButton;
